import { render, staticRenderFns } from "./Stomerij.vue?vue&type=template&id=ceed9a5a&scoped=true"
import script from "./Stomerij.vue?vue&type=script&lang=js"
export * from "./Stomerij.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceed9a5a",
  null
  
)

export default component.exports